import { Team, TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamOwnershipTransferReq, teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface TransferTeamOwnershipParams {
  teamId: string;
  teamOwnershipTransferReq: TeamOwnershipTransferReq;
}

interface TransferTeamOwnershipResult {
  team: Team;
  previousOwnerMembership: TeamMember;
  newOwnerMembership: TeamMember;
}

export const useTransferTeamOwnership = () => {
  const queryClient = useQueryClient();

  const transferTeamOwnershipMutation = useMutation({
    mutationFn: ({ teamId, teamOwnershipTransferReq }: TransferTeamOwnershipParams) => {
      return teamApi.transferTeamOwnership(teamId, teamOwnershipTransferReq).then(({ data }) => {
        return {
          team: data.team as Team,
          previousOwnerMembership: data.previousOwnerMembership as TeamMember,
          newOwnerMembership: data.newOwnerMembership as TeamMember,
        } as TransferTeamOwnershipResult;
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    transferTeamOwnership: transferTeamOwnershipMutation.mutateAsync,
    isTransferringTeamOwnership: transferTeamOwnershipMutation.isPending,
    ...transferTeamOwnershipMutation,
  };
};
